<template>
	<div class="pdf-iframe-box">
		<iframe style="width: 100vw;height: 100vh;" :src="pdfUrl" frameborder="0" class="pdf-iframe"></iframe>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				pdfUrl: '',

			}

		},
		mounted() {

			console.log("this.$route.query.url==" + this.$route.query.url);
			if (this.$route.query.url) {
				this.pdfUrl = "/pdf/web/viewer.html?file=" + decodeURIComponent(this.$route.query.url);
				console.log("this.pdfUrl'===" + this.pdfUrl);

			}

			if (this.$route.query.title) {
				document.title = decodeURIComponent(this.$route.query.title)
			}

			document.oncontextmenu = e => e.preventDefault()
			document.onkeydown = e => {
				if ((e.ctrlKey || e.metaKey) && e.key === 'p') e.preventDefault()
			}

			document.addEventListener('keydown', function(event) {
				if (event.key === 'F12') {
					event.preventDefault();
				}
				if (event.key === 'F5') {
					event.preventDefault();
				}
			});
			document.addEventListener('contextmenu', function(e) {
				e.preventDefault();
			});

			this.getconfig()


		},
		methods: {
			getconfig() {
				this.$api.config({}).then((res) => {
					console.log(res);

					var link = document.querySelector("link[rel~='icon']");
					if (!link) {
						link = document.createElement('link');
						link.rel = 'icon';
						document.head.appendChild(link);
					}
					link.href = res.data.url_logo
				}).catch((error) => {
					if (error.code == 450) {
						localStorage.removeItem('userInfo')
						localStorage.removeItem('token')
						this.$router.go(0)
					}
				})
			},
		}

	}
</script>

<style scoped>
	.pdf-iframe-box {
		width: 100vw;
		height: 100vh;
		user-select: none;
		-webkit-user-select: none;
	}
</style>